import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class SalesSalesOrderActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Bakery/SalesOrderOnline/SalesOrderBrowser")
	}

	render() {
		return (
			<Activity 
				name="SalesOrderOnline"
				RenderedComponent={this.RenderedComponent}
				context="SalesOrderOnline"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SalesSalesOrderActivity)
